var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"id":_vm.id,"x-small":""},on:{"mouseover":_vm.over,"mouseleave":_vm.leave}},[_vm._v(" "+_vm._s(_vm.schema.connections.length)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }